// profileExtension.ts
import { clientConnector } from '@games/socket-client'

type ProfileCallback = (error: string | null, response: unknown) => void

/**
 * Расширяет clientConnector для работы с комнатами
 */
export function extendSocketWithBattleInitData(): void {
  // Регистрируем один компонент со всеми методами комнаты
  const statsComponent = {
    name: 'battleHeroes',
    methods: {
      // Методы для отправки запросов (с ожиданием ответа)
      publish: {
        emitEvent: 'battleHeroes:publish',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onBattleInitHeroesConfirmed'
      },
      getByPlayerId: {
        emitEvent: 'battleHeroes:getByPlayerId',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onBattleInitHeroesReceived'
      },
    }
  }
  
  // Регистрируем компонент без возврата результата
  clientConnector.registerComponent(statsComponent);
}